import React from "react"
import propTypes from "prop-types"
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input } from "reactstrap"

const EmitterSection = ({ 
    values, 
    errors, 
    touched, 
    handleChange, 
    handleBlur
}) => {
    // Apartado del emisor
    return (
        <Card className="mb-3">
            <CardHeader className="py-2">
                <h5 className="mb-0">Emisor:</h5>
            </CardHeader>
            <CardBody className="p-3">
                <Row className="mb-3">
                    <Col md="12">
                        <FormGroup>
                            <Label for="emitterCompanyName">Razón social: *</Label>
                            <Input 
                                type="text" 
                                name="emitterCompanyName"
                                disabled
                                value={values.emitterCompanyName} 
                                onChange={handleChange} 
                                onBlur={handleBlur} 
                                invalid={
                                    touched.emitterCompanyName 
                                    && errors.emitterCompanyName
                                } 
                            />
                            {touched.emitterCompanyName 
                                && errors.emitterCompanyName && (
                                <div className="invalid-feedback">
                                    {errors.emitterCompanyName}
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label for="emitterRfc">RFC: *</Label>
                            <Input 
                                type="text" 
                                name="emitterRfc"
                                disabled
                                value={values.emitterRfc} 
                                onChange={handleChange} 
                                onBlur={handleBlur} 
                                invalid={touched.emitterRfc && errors.emitterRfc} 
                            />
                            {touched.emitterRfc && errors.emitterRfc && (
                                <div className="invalid-feedback">
                                    {errors.emitterRfc}
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label for="emitterFiscalRegimen">
                                Régimen Fiscal: *
                            </Label>
                            <Input
                                type="text"
                                name="emitterFiscalRegimen"
                                disabled
                                value={values.emitterFiscalRegimen}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                invalid={
                                    touched.emitterFiscalRegimen
                                    && errors.emitterFiscalRegimen
                                }
                            />
                            {touched.emitterFiscalRegimen 
                                && errors.emitterFiscalRegimen && (
                                <div className="text-danger small mt-1">
                                    {errors.emitterFiscalRegimen}
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label for="emitterPostalCode">Código postal: *</Label>
                            <Input 
                                type="text"
                                name="emitterPostalCode"
                                disabled
                                value={values.emitterPostalCode} 
                                onChange={handleChange} 
                                onBlur={handleBlur} 
                                invalid={
                                    touched.emitterPostalCode 
                                    && errors.emitterPostalCode
                                } 
                            />
                            {touched.emitterPostalCode 
                                && errors.emitterPostalCode && (
                                <div className="invalid-feedback">
                                    {errors.emitterPostalCode}
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

EmitterSection.propTypes = {
    values: propTypes.object.isRequired,
    errors: propTypes.object.isRequired,
    touched: propTypes.object.isRequired,
    handleChange: propTypes.func.isRequired,
    handleBlur: propTypes.func.isRequired
}

export default EmitterSection
